import React from 'react';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { OrderSummary } from 'features/dashboard/ts/OrderSummary';
import { useTranslation } from 'hooks/useTranslation';

import { useStyles } from './styles';

export type GiftOrderSummaryItemSize = 'small' | 'medium';

interface GiftOrderSummaryItemProps {
  summaryItem: OrderSummary;
  size: GiftOrderSummaryItemSize;
  isLast: boolean;
}

export const GiftOrderSummaryItem = ({
  summaryItem: { currency, products, remaining },
  size,
  isLast,
}: GiftOrderSummaryItemProps) => {
  const { t } = useTranslation('dashboard');
  const classes = useStyles({ size });
  return (
    <Box flex={1} display="flex" flexDirection="column" alignItems="space-between">
      {products?.map(({ product, cards, spend }, index) => (
        <Box
          key={`${product}-${index}`}
          paddingBottom={size === 'medium' ? 8.5 : 4}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Typography className={classes.productText}>{product}</Typography>
            <Typography color="textSecondary" variant="subtitle1" className={clsx(classes.cardsQuantityText)}>
              {cards} {t('cards')}
            </Typography>
          </Box>
          <Box>
            <Typography className={clsx(classes.textFont, classes.spendAmount)}>
              - {Number(spend).toLocaleString('currency', { maximumFractionDigits: 2 })} {currency}
            </Typography>
          </Box>
        </Box>
      ))}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        paddingBottom={size === 'medium' && !isLast ? 20 : 0}
      >
        <Typography className={clsx(classes.textFont)}>{t('remaining')}</Typography>
        <Box className={classes.remainingAmountContainer} paddingTop={size === 'medium' ? 16 : 6}>
          <Typography className={clsx(classes.textFont, classes.remainingAmount)}>
            {Number(remaining).toLocaleString('currency', { maximumFractionDigits: 2 })} {currency}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
